export default "__VITE_ASSET__a3be06bb__"